import { numbersOnly } from '@forms/helpers/normalisers';

export const getNumericValueFromString = (value: string) => {
    return parseInt(numbersOnly(value), 10);
};
